import { api } from './client'

const emailService = {
  getTemplates: (objectType) => api.get('/email/templates', { objectType }),
  getSections: (objectType) => api.get('/email/sections', { objectType }),
  send: (data) => api.post('/email/send', data),
  getSettings: () => api.get('/email/settings'),
  // saveSettings (POST /email/settings) was removed with its cb-api route (spec 183,
  // CC-54198): nothing called it, and it relayed a whole body to CB's SMTP-credential write.
  // Bulk invoice email: `{ templateId, resultsId }` only — cb-api binds the sender to the
  // signed-in user and refuses any sender key (spec 183, CC-54197).
  bulkSend: (data) => api.post('/email/bulk', data),
}

export default emailService
